
export default {
  props: {
    post: {
      type: Object,
      required: true,
    },
    fixture: {
      type: Object,
      required: true,
    },
  },
  computed: {
    showExcerpt () {
      return this.post.acf?.show_excerpt_on_post?.show_excerpt_on_post;
    },
  },
  methods: {
    isPageType (types = []) {
      let type = this.post.type;
      if (this.isTypeOverride(types, this.post.type)) {
        return true;
      }

      if (this.post.terms.length) {
        const term = this.post.terms.find(term => term.taxonomy === `page_type`);
        type = term ? term.slug : this.post.type;
      }
      if (types.includes(type)) {
        return true;
      }
      return false;
    },
    isTypeOverride (types, type) {
      const overrides = [`report`, `live`, `match_preview`];
      if (overrides.includes(type) && types.some(type => overrides.includes(type))) {
        return true;
      }
    },
  },
};
